import type Cookies from 'js-cookie';

/**
 * The auth cookie's attributes, in ONE place.
 *
 * These were previously inlined in AuthContext, AuthenticationForm, and (GB
 * #677) the recovery route — three copies that had to move together, with a
 * comment in one of them asking future readers not to let them drift. They
 * live here so drift is impossible and so a test can assert against the real
 * values rather than a mock's idea of them.
 *
 * ⚠ `expires: 1` is ONE DAY, while the Firebase ID token inside the cookie
 * lasts one hour. That mismatch is the whole of GB #677 — it is deliberate and
 * load-bearing, not an oversight. Shortening it does not fix #677 (the user
 * still gets bounced, just down a different branch) and would cost the
 * server-side forward that shipped in #1463. The recovery route handles the
 * gap instead.
 */
export const AUTH_COOKIE_OPTS: Cookies.CookieAttributes = {
  expires: 1,
  sameSite: 'lax',
  secure: process.env.NODE_ENV === 'production',
};
